import { SET_PERMISSIONS } from './types';

export const setPermissions = permissoes => ({ type: SET_PERMISSIONS, payload: permissoes })